import React from "react";
import moment from "moment-timezone";
import NavSide from "./components/sideNav";
import ProgressBar from "./components/pb";

import "../src/pbStyle.css";

const queryString = require("query-string");

// ── Persistent auth storage ──────────────────────────────────────────────────
const STORAGE_SID    = "irr_sid";
const STORAGE_SID_BK = "irr_sid_backup";
const STORAGE_BASE   = "irr_baseUrl";
const STORAGE_HOST   = "irr_hostUrl";
const STORAGE_ACT_AS = "irr_actAs";

function loadStoredAuth() {
  return {
    sid:     localStorage.getItem(STORAGE_SID)    || "",
    sidBk:   localStorage.getItem(STORAGE_SID_BK) || "",
    baseUrl:  localStorage.getItem(STORAGE_BASE)   || "https://hst-api.wialon.com",
    hostUrl:  localStorage.getItem(STORAGE_HOST)   || "",
    actAs:    localStorage.getItem(STORAGE_ACT_AS) || "",
  };
}

function saveNewSid(sid, baseUrl, actAs, hostUrl) {
  if (!sid) return;
  const prev = localStorage.getItem(STORAGE_SID);
  if (prev && prev !== sid) localStorage.setItem(STORAGE_SID_BK, prev); // keep old as backup
  localStorage.setItem(STORAGE_SID, sid);
  if (baseUrl) localStorage.setItem(STORAGE_BASE, baseUrl);
  if (hostUrl) localStorage.setItem(STORAGE_HOST, hostUrl);
  if (actAs) localStorage.setItem(STORAGE_ACT_AS, actAs);
}

function cleanUrl() {
  const url = new URL(window.location.href);
  ["sid", "authHash", "baseUrl", "hostUrl", "user", "operateAs", "actAs"].forEach(p => url.searchParams.delete(p));
  window.history.replaceState({}, "", url.search ? url.toString() : url.pathname);
}
// ────────────────────────────────────────────────────────────────────────────

const routesList = require("../src/files/lists.json").st;
const zones = require("../src/files/stations.json").stationsArr;

/* global wialon */

const groupReport = "avl_unit_group";
const unitReport = "avl_unit";
const zoneGroupToFind = "المحطات";

// Main app class
const mainRoutes = require("./files/lists.json").main_routes;
const targetObjects = require("./files/lists.json").target_objects;

const defaultSelectedArr = "baghdad_om-kaser";

const UPDATE_INTERVAL = 120000; // 2 minutes
class App extends React.Component {
  constructor() {
    super();
    this.state = {
      isTried: false,
      authFailed: false,
      sessionID: "",
      dataset: [],
      resultData: [], // col of response
      points: [],
      addedUnits: [],
      selectedArrName: defaultSelectedArr,
      isAuthorized: false,
      units: [],
      groups: [],
      reports: [],
      routes: [],
      selectedTargetObject: targetObjects[1], // unit is default value
      resources: [],
      selectedDayDate: new Date(),
      mainRoutes: mainRoutes,
      fromList: mainRoutes,
      toList: mainRoutes[0].end_points,
      selectedFromStation: mainRoutes[0],
      selectedToStation: mainRoutes[0].end_points[0],
      targetObjects: targetObjects,
      exeReportConfig: {
        res: {},
        groupReport: {}, // put report when we found it in res iteration
        unitReport: {},
        unitGroup: {},
        unit: {},
        interval: {
          from: -1,
          to: -1,
          flags: wialon.item.MReport.intervalFlag.absolute
        },
        type: "avl_unit_group"
      },
      executing: true,
      mode: "select",
      zones: [],
      chartConfig: {
        min: 1,
        max: routesList[defaultSelectedArr].length
      },
      chartData: [],
      randomColor: false,
      colors: [],
      colorsObject: [],
      yDirection: mainRoutes[0].end_points[0].direction // default
    };

    this.timerID = 0;      // single refresh interval — never mirrored into state
    this._localeSet = false; // set_locale is per-SID server state, sent once
    this._sessionDead = false;

    this.onChangeTargetObjects = this.onChangeTargetObjects.bind(this);
    this.onDayDateSelect = this.onDayDateSelect.bind(this);
    this.onFromStationChange = this.onFromStationChange.bind(this);
    this.onToStationChange = this.onToStationChange.bind(this);
    this.onUnitChange = this.onUnitChange.bind(this);
    this.onGroupChange = this.onGroupChange.bind(this);
    this.onCustomColorChange = this.onCustomColorChange.bind(this);
    this.onDirectionChange = this.onDirectionChange.bind(this);
    this.execute = this.execute.bind(this);
  }

  setStateAsync(state) {
    return new Promise(resolve => this.setState(state, resolve));
  }

  componentDidMount() {
    console.log("[IRR] componentDidMount — isTried:", this.state.isTried);
    if (!this.state.isTried) {
      this.setState({ isTried: true });
      this._startAuth();
    }
  }

  // Auth: URL SID → duplicate → save new SID. Stored SID → use directly. Nothing else.
  _startAuth() {
    const parsedQuery = queryString.parse(this.props.location.search);
    const urlSid     = parsedQuery.sid;
    const urlBase    = parsedQuery.baseUrl;
    const urlHost    = parsedQuery.hostUrl;
    const urlActAs   = parsedQuery.user || parsedQuery.operateAs || parsedQuery.actAs || "";
    const stored  = loadStoredAuth();
    const effectiveBase = urlBase || stored.baseUrl;
    const effectiveHost = urlHost || stored.hostUrl || "";
    const effectiveActAs = urlActAs || stored.actAs;
    this._authHostUrl = effectiveHost;
    console.log("[IRR] _startAuth | urlSid:", !!urlSid, "| stored:", !!stored.sid, "| base:", effectiveBase, "| host:", effectiveHost || "(none)", "| actAs:", effectiveActAs || "(none)");

    if (urlSid) {
      cleanUrl();
      // Step 1: duplicate (creates new session, keeps original alive)
      this._doDuplicate(urlSid, effectiveBase, effectiveActAs, effectiveHost, () => {
        console.log("[IRR] duplicate failed — trying URL SID directly");
        // Step 2: try URL SID directly (duplicate may have failed due to server mismatch)
        this._doRealSid(urlSid, effectiveBase, () => {
          // Step 3: fall back to stored SID
          if (stored.sid && stored.sid !== urlSid) {
            this._doRealSid(stored.sid, stored.baseUrl, () => this._failAuth(), false, stored.actAs, stored.hostUrl);
          } else {
            this._failAuth();
          }
        }, true /* skipRemove — URL SID was never stored */, effectiveActAs, effectiveHost);
      });
      return;
    }

    const { sid, sidBk, baseUrl, hostUrl, actAs } = stored;
    if (sid) {
      console.log("[IRR] using stored SID");
      this._doRealSid(sid, baseUrl, () => {
        if (sidBk && sidBk !== sid) {
          this._doRealSid(sidBk, baseUrl, () => this._failAuth(), true, actAs, hostUrl);
        } else {
          this._failAuth();
        }
      }, true, actAs, hostUrl);
    } else {
      this._failAuth();
    }
  }

  _failAuth() {
    console.warn("[IRR] no working SID — showing auth-failed screen");
    const hostUrl = this._authHostUrl || "";
    if (this._authRedirectTimer) clearTimeout(this._authRedirectTimer);
    this.setState({ authFailed: true, redirectHostUrl: hostUrl });
    if (hostUrl) {
      this._authRedirectTimer = setTimeout(() => {
        window.location.href = hostUrl;
      }, 5000);
    }
  }

  _stopPolling() {
    if (this.timerID) {
      clearInterval(this.timerID);
      this.timerID = 0;
    }
  }

  // Session died (expired, or the parent SID we duplicated from logged out).
  // The SDK drops its sid and keeps firing requests with an empty one, so stop
  // polling and send the user back to re-auth instead of alerting on every tick.
  _sessionLost(reason) {
    if (this._sessionDead) return; // in-flight requests all fail at once
    this._sessionDead = true;
    console.warn("[IRR] session lost —", reason);
    this._stopPolling();
    this._localeSet = false;
    localStorage.removeItem(STORAGE_SID);
    this.setState({ executing: false });
    this._failAuth();
  }

  // URL SID → inject, then duplicate(...) → keeps original alive, returns a NEW SID we save.
  _doDuplicate(sid, baseUrl, operateAs, hostUrl, onFail) {
    const sess = wialon.core.Session.getInstance();
    sess.initSession(baseUrl, "IRR-Chart");
    console.log("[IRR] _doDuplicate → base:", baseUrl, "| sid:", sid.slice(0, 8) + "...", "| actAs:", operateAs || "(none)");

    let fired = false;
    const watchdog = setTimeout(() => {
      if (!fired) { console.error("[IRR] WATCHDOG: duplicate callback never fired"); onFail && onFail(); }
    }, 8000);

    const cb = async (code, data) => {
      fired = true;
      clearTimeout(watchdog);
      const newSid = sess.getId ? sess.getId() : sess._sid;
      console.log("[IRR] duplicate callback — code:", code, "| new SID:", newSid ? newSid.slice(0, 8) + "..." : "(none)");
      if (code) {
        console.warn("[IRR] duplicate failed code", code, wialon.core.Errors.getErrorText(code));
        if (onFail) onFail();
        return;
      }
      saveNewSid(newSid, baseUrl, operateAs, hostUrl);
      this._localeSet = false; // new SID → locale must be sent again
      this._sessionDead = false;
      await this.setStateAsync({ isAuthorized: true });
      await this.init2();
    };

    try {
      sess.duplicate(sid, operateAs || "", true, cb);
    } catch (e) {
      fired = true;
      clearTimeout(watchdog);
      console.error("[IRR] duplicate threw:", e);
      if (onFail) onFail();
    }
  }

  // Stored SID → restore through the SDK; init2()/setup() validate it.
  async _doRealSid(sid, baseUrl, onFail, skipRemove, operateAs, hostUrl) {
    console.log("[IRR] _doRealSid — SID:", sid.slice(0, 8) + "...", "| actAs:", operateAs || "(none)");
    const sess = wialon.core.Session.getInstance();
    sess.initSession(baseUrl, "IRR-Chart");
    this._sidOnFail = () => {
      if (!skipRemove) localStorage.removeItem(STORAGE_SID);
      if (onFail) onFail();
    };
    this._sidBaseUrl = baseUrl;
    this._sidOperateAs = operateAs;
    this._sidHostUrl = hostUrl;

    const cb = async code => {
      if (code) {
        console.warn("[IRR] restore saved SID failed code", code, wialon.core.Errors.getErrorText(code));
        if (this._sidOnFail) {
          const fn = this._sidOnFail;
          this._sidOnFail = null;
          this._sidBaseUrl = null;
          this._sidOperateAs = null;
          this._sidHostUrl = null;
          fn();
        }
        return;
      }

      saveNewSid(sess.getId ? sess.getId() : sid, baseUrl, operateAs, hostUrl);
      this._localeSet = false; // new SID → locale must be sent again
      this._sessionDead = false;
      this._forceReloadDataFlags = true;
      await this.setStateAsync({ isAuthorized: true });
      await this.init2();
    };

    try {
      // restore=true rehydrates the saved SID; it does not create a fresh duplicate SID.
      sess.duplicate(sid, "", true, cb, true);
    } catch (e) {
      console.error("[IRR] restore saved SID threw:", e);
      if (this._sidOnFail) {
        const fn = this._sidOnFail;
        this._sidOnFail = null;
        this._sidBaseUrl = null;
        this._sidOperateAs = null;
        this._sidHostUrl = null;
        fn();
      }
    }
  }

  componentWillUnmount() {
    this._stopPolling();
    if (this._authRedirectTimer) {
      clearTimeout(this._authRedirectTimer);
    }
  }
  onDirectionChange(e) {
    this.setState({
      ...this.state,
      yDirection: this.state.yDirection == "up" ? "down" : "up"
    });
  }
  async onCustomColorChange(e) {
    if (e) {
      await this.setState({
        ...this.state,
        randomColor: e.target.checked,
        executing: true
      });
      this.buildChartObj3(this.state.resultData);
    }
  }
  onUnitChange(e, value) {
    if (value) {
      let that = this;
      this.setState({
        exeReportConfig: {
          ...that.state.exeReportConfig,
          unit: value
        }
      });
    }
  }
  onGroupChange(e, value) {
    if (value) {
      let that = this;
      this.setState({
        exeReportConfig: {
          ...that.state.exeReportConfig,
          unitGroup: value
        }
      });
    }
  }

  async init2() {
    const sess = wialon.core.Session.getInstance(); // get instance of current Session
    // flags to specify what kind of data should be returned
    let res_flags =
      wialon.item.Item.dataFlag.base | wialon.item.Resource.dataFlag.reports;

    res_flags = 1060865; //
    sess.loadLibrary("itemCustomFields");
    sess.loadLibrary("resourceReports");
    sess.loadLibrary("resourceZoneGroups");
    sess.loadLibrary("resourceZones");

    const activeSid = sess.getId ? sess.getId() : sess._sid;
    console.log("[IRR] init2 — SID before updateDataFlags:", activeSid || "(EMPTY)");
    let that = this;
    const specs = [
      { type: "type", data: "avl_resource", flags: res_flags, mode: 0 },
      { type: "type", data: "avl_unit_group", flags: 1 + 8, mode: 0 },
      { type: "type", data: "avl_unit", flags: 1 + 8, mode: 0 }
    ];
    const loadFlags = () => {
      sess.updateDataFlags(
        specs, // Items specification
        async function(code) {
          await that.setup(sess, code);
        }
      );
    };

    if (this._forceReloadDataFlags) {
      this._forceReloadDataFlags = false;
      console.log("[IRR] init2 — clearing restored data flags before reload");
      sess.updateDataFlags(
        specs.map(spec => ({ ...spec, mode: 2 })),
        function(code) {
          if (code) console.warn("[IRR] clear data flags failed code", code, wialon.core.Errors.getErrorText(code));
          loadFlags();
        }
      );
    } else {
      loadFlags();
    }
    await this.setStateAsync({
      sessionID: sess
    });
  }

  render() {
    const { isAuthorized, authFailed, redirectHostUrl } = this.state;

    if (authFailed) {
      return (
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          height: "100vh", background: "#f3f1ec", flexDirection: "column", gap: 12,
          fontFamily: "Cairo, sans-serif", textAlign: "center", padding: 24,
        }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#1c1a16" }}>انتهت صلاحية الجلسة</div>
          <div style={{ fontSize: 13, color: "#5a5448", maxWidth: 440, lineHeight: 1.8 }}>
            يرجى فتح الرابط من Wialon مرة أخرى للحصول على جلسة جديدة.
          </div>
          <div style={{ fontSize: 11, color: "#8a7f72", maxWidth: 440, lineHeight: 1.7, marginTop: 4 }}>
            تأكد من أن الرابط يحتوي على المعامل <code style={{ background: "#e8e4dd", padding: "1px 5px", borderRadius: 3 }}>?sid=...</code>
            {" "}وإذا كان الخادم مختلفاً أضف{" "}
            <code style={{ background: "#e8e4dd", padding: "1px 5px", borderRadius: 3 }}>
              &amp;baseUrl=https://your-api.wialon.com&amp;hostUrl=https://your-wialon-host.com
            </code>
          </div>
          {redirectHostUrl && (
            <div style={{ fontSize: 12, color: "#6f665b", maxWidth: 440, lineHeight: 1.7 }}>
              ط³ظٹطھظ… ط¥ط¹ط§ط¯ط© طھظˆط¬ظٹظ‡ظƒ ط®ظ„ط§ظ„ 5 ط«ظˆط§ظ†ظچ ط¥ظ„ظ‰ Wialon.
            </div>
          )}
          <button
            onClick={() => { localStorage.clear(); window.location.reload(); }}
            style={{
              marginTop: 12, padding: "7px 20px", background: "#3b3325", color: "#fff",
              border: "none", borderRadius: 6, cursor: "pointer", fontSize: 13,
              fontFamily: "Cairo, sans-serif"
            }}
          >
            مسح البيانات المحفوظة وإعادة المحاولة
          </button>
        </div>
      );
    }

    const loading = !isAuthorized || this.state.executing || !this.state.dataset;

    if (loading) {
      return (
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          height: "100vh", background: "#f3f1ec", flexDirection: "column", gap: 16
        }}>
          <ProgressBar color="primary" />
          <span style={{ color: "#5a5448", fontFamily: "Cairo, sans-serif", fontSize: 14 }}>
            {!isAuthorized ? "جارٍ تسجيل الدخول..." : "جارٍ تحميل البيانات..."}
          </span>
        </div>
      );
    }

    return (
      <NavSide
        values={{
          selectedTargetObject: this.state.selectedTargetObject,
          selectedDayDate: this.state.selectedDayDate,
          selectedFromStation: this.state.selectedFromStation,
          selectedToStation: this.state.selectedToStation,
          selectedGroup: this.state.exeReportConfig.unitGroup,
          selectedUnit: this.state.exeReportConfig.unit,
          customColor: this.state.randomColor,
          yDirection: this.state.yDirection
        }}
        lists={{
          fromList: this.state.fromList,
          toList: this.state.toList,
          units: this.state.units,
          groups: this.state.groups,
          routes: this.state.routes,
          targetObjects: this.state.targetObjects,
          points: this.state.points,
          colors: this.state.colors
        }}
        functions={{
          onChangeTargetObjects: this.onChangeTargetObjects,
          onGroupChange: this.onGroupChange,
          onUnitChange: this.onUnitChange,
          onDayDateChange: this.onDayDateSelect,
          onFromStationChange: this.onFromStationChange,
          onToStationChange: this.onToStationChange,
          execute: this.execute,
          onCustomColorChange: this.onCustomColorChange,
          onDirectionChange: this.onDirectionChange
        }}
        zones={zones}
        data={this.state}
        conf={{ yMax: zones.length > 0 ? zones.length - 1 : 0 }}
      />
    );
  }

  onDayDateSelect(e) {
    if (e)
      this.setState({
        selectedDayDate: e
      });
  }
  async setup(sess, code) {
    // updateDataFlags callback
    if (code) {
      console.warn("[IRR] setup — error code:", code, wialon.core.Errors.getErrorText(code));
      if (this._sidOnFail) {
        const fn = this._sidOnFail;
        this._sidOnFail  = null;
        this._sidBaseUrl = null;
        this._sidOperateAs = null;
        this._sidHostUrl = null;
        await this.setStateAsync({ isAuthorized: false }); // revert so loading screen shows
        fn(); // try next auth method in chain
        return;
      }
      alert(wialon.core.Errors.getErrorText(code));
      return;
    }

    // SID was accepted — save it (covers the _doRealSid success path)
    const activeSid = sess.getId ? sess.getId() : sess._sid;
    if (this._sidOnFail !== undefined && activeSid) {
      saveNewSid(activeSid, this._sidBaseUrl || "https://hst-api.wialon.com", this._sidOperateAs, this._sidHostUrl);
    }
    this._sidOnFail  = null;
    this._sidBaseUrl = null;
    this._sidOperateAs = null;
    this._sidHostUrl = null;

    const resourcesReady = await this.collectResources(sess);
    if (!resourcesReady) {
      await this.setStateAsync({ executing: false });
      return;
    }

    const reportsReady = await this.findReports();
    if (!reportsReady) {
      alert("required reports not found");
      await this.setStateAsync({ executing: false });
      return;
    }

    await this.findStationGroup();
    let zonesArr = await this.findZones();
    await this.setStateAsync({ zones: zonesArr, executing: true });
    setTimeout(() => {
      console.log("[IRR] setup — auto executing initial report");
      this.executeReport1(sess);
    }, 0);
  }

  async collectResources(sess) {
    const res = sess.getItems("avl_resource");
    if (!res || !res.length) {
      alert("resources not found");
      return false;
    }

    // get loaded 'avl_unit's items
    const units = sess.getItems("avl_unit");
    if (!units || !units.length) {
      alert("Units not found");
      return false;
    } // check if units found
    units.sort(function(a, b) {
      if (a.$$user_name > b.$$user_name) return 1;
      if (a.$$user_name < b.$$user_name) return -1;
      return 0;
    });
    const unitGroupsArr = sess.getItems("avl_unit_group");

    if (!unitGroupsArr || !unitGroupsArr.length) {
      alert("groups not found");
      return false;
    }
    await this.setStateAsync({
      resources: res,
      units: units,
      groups: unitGroupsArr
    });
    return true;
  }

  async findReports() {
    let isGroupReportFound = false;
    let isUnitReportFound = false;
    let tempExeReport = {
      res: {},
      groupReport: {}, // put report when we found it in res iteration
      unitReport: {},
      unitGroup: {},
      unit: {},
      interval: {
        from: -1,
        to: -1,
        flags: wialon.item.MReport.intervalFlag.absolute
      },
      type: groupReport
    };
    for (var i in this.state.resources) {
      if (this.state.resources[i].hasOwnProperty("$$user_reports")) {
        if (isGroupReportFound && isUnitReportFound) {
          break;
        }

        var rep = this.state.resources[i].getReports();
        for (var j in rep) {
          if (
            rep[j].ct === "avl_unit_group" &&
            rep[j].n === "ENTRANCE TO STATION - GROUPS"
          ) {
            tempExeReport.groupReport = rep[j];
            isGroupReportFound = true;
            tempExeReport.res = this.state.resources[i];
            tempExeReport.unit = this.state.units[0];
            tempExeReport.unitGroup = this.state.groups[0]; //. set default

            tempExeReport.interval = {
              from: 1574542800,
              to: -1,
              flags: wialon.item.MReport.intervalFlag.absolute
            };
          }
          if (
            rep[j].ct === "avl_unit" &&
            rep[j].n === "ENTRANCE TO STATION - UNITS"
          ) {
            tempExeReport.unitReport = rep[j];
            isUnitReportFound = true;

            tempExeReport.res = this.state.resources[i];
            tempExeReport.unit = this.state.units[0];
            tempExeReport.unitGroup = this.state.groups[0]; //. set default
            tempExeReport.interval = {
              from: 1574542800,
              to: 0,
              flags: wialon.item.MReport.intervalFlag.absolute
            };
          }
          if (isGroupReportFound && isUnitReportFound) {
            break;
          }
        }
      }
    }
    console.log("[IRR] findReports — group:", isGroupReportFound, "| unit:", isUnitReportFound);
    await this.setStateAsync({ exeReportConfig: tempExeReport });
    return isGroupReportFound && isUnitReportFound;
  }

  findStationGroup() {
    let stationsGroup;
    if (!this.state.exeReportConfig.res.hasOwnProperty("$$user_zonesGroups")) {
      alert("zones group not found");
      return stationsGroup;
    }
    // now get geo group
    var isGroupFound = false;
    for (var i in this.state.exeReportConfig.res.$$user_zonesGroups) {
      if (
        this.state.exeReportConfig.res.$$user_zonesGroups[i].n ===
        zoneGroupToFind
      ) {
        stationsGroup = this.state.exeReportConfig.res.$$user_zonesGroups[i].n;
        isGroupFound = true;
        break;
      }
    }
    if (!stationsGroup) {
      console.warn("[IRR] station zone group not found:", zoneGroupToFind);
      alert("zones group not found: " + zoneGroupToFind);
    }
    return stationsGroup;
  }
  findZones() {
    if (!this.state.exeReportConfig.res.hasOwnProperty("$$user_zones")) {
      alert("zones not found");
      return [];
    }
    return this.state.exeReportConfig.res.$$user_zones;
  }

  async executeReport1(sess) {
    let that = this;
    if (!this.state.exeReportConfig.res.hasOwnProperty("_id")) {
      alert("no resource found");
      await this.setStateAsync({ executing: false });
      return;
    }

    // getRenderer() returns null once the session is invalidated
    const renderer = sess && sess.getRenderer ? sess.getRenderer() : null;
    if (!renderer) {
      this._sessionLost("renderer unavailable");
      return;
    }

    // locale is server-side session state — already sent for this SID
    if (this._localeSet) {
      await this.executeReport2(sess);
      return;
    }

    // setLocalTime Zone
    var localeObj = { flags: 0, formatDate: "%25Y-%25m-%25E %25H:%25M:%25S" };
    renderer.setLocale(134228528, "en", localeObj, async function(code) {
      if (code) {
        console.warn("[IRR] setLocale failed code", code, wialon.core.Errors.getErrorText(code));
        if (Number(code) === 1) {
          that._sessionLost("setLocale — invalid session");
          return;
        }
        await that.setStateAsync({ executing: false });
        return;
      }
      that._localeSet = true;
      // execute now
      await that.executeReport2(sess);
    });
  }
  async executeReport2(sess) {
    var res3 = sess.getItem(this.state.exeReportConfig.res._id);

    var temp = {};

    var objectID = 0;
    if (this.state.exeReportConfig.type == groupReport) {
      objectID = this.state.exeReportConfig.unitGroup._id;
      temp = res3.getReport(this.state.exeReportConfig.groupReport.id);
    }
    if (this.state.exeReportConfig.type == unitReport) {
      objectID = this.state.exeReportConfig.unit._id;
      temp = res3.getReport(this.state.exeReportConfig.unitReport.id);
    }

    if (!res3 || !temp || !objectID) {
      console.warn("[IRR] report config incomplete", {
        hasResource: !!res3,
        hasReport: !!temp,
        objectID,
        type: this.state.exeReportConfig.type
      });
      alert("report configuration not found");
      await this.setStateAsync({ executing: false });
      return;
    }
    let fromUnix = 0;
    let toUnix = 0;

    if (this.state.mode == "today") {
      fromUnix = moment()
        .startOf("day")
        .unix();

      toUnix = Math.round(new Date().getTime() / 1000);
    }
    if (this.state.mode == "select") {
      let dayDate = this.state.selectedDayDate;
      let startOfDay = new Date(
        dayDate.getFullYear(),
        dayDate.getMonth(),
        dayDate.getDate()
      );
      fromUnix = Math.floor(startOfDay.getTime() / 1000);
      toUnix = fromUnix + (23 * 3600 + 59 * 60);
    }
    const interval = {
      ...this.state.exeReportConfig.interval,
      from: fromUnix,
      to: toUnix
    };

    await this.setStateAsync(prevState => ({
      ...prevState,
      exeReportConfig: {
        ...prevState.exeReportConfig,
        interval
      }
    }));

    let that = this;
    let reportReturned = false;
    const reportWatchdog = setTimeout(() => {
      if (!reportReturned) {
        console.warn("[IRR] execReport watchdog timed out", {
          objectID,
          reportID: temp && temp.id,
          interval
        });
        that.setState({ executing: false });
      }
    }, 30000);

    console.log("[IRR] execReport", {
      objectID,
      reportID: temp && temp.id,
      type: this.state.exeReportConfig.type,
      interval
    });
    res3.execReport(
      temp,
      objectID,
      0,
      interval, // execute selected report
      async function(code, data) {
        reportReturned = true;
        clearTimeout(reportWatchdog);
        if (code) {
          console.warn("[IRR] execReport failed code", code, wialon.core.Errors.getErrorText(code));
          if (Number(code) === 1) {
            that._sessionLost("execReport — invalid session");
            return;
          }
          alert(wialon.core.Errors.getErrorText(code));
          await that.setStateAsync({ executing: false });
          return;
        } // exit if error code
        if (!data.getTables().length) {
          alert("No data for selected train!");
          await that.setStateAsync({ executing: false });

          return;
        } else {
          let table = data.getTables()[0];

          var configObj = {
            type: "range",
            data: { from: 0, to: table.rows, level: 5, flat: 0, rawValues: 0 }
          };

          var isDataGot = false;
          data.selectRows(0, configObj, function(code2, col) {
            if (code2) {
              that.setState({ executing: false });
              return;
            }

            if (col) {
              that.buildChartObj3(col);
            }
            that.setState({ executing: false, resultData: col });
            that.updateSeries();
          });
        }
      }
    );
  }
  updateSeries() {
    if (this.timerID) return; // exactly one refresh interval for the app's lifetime
    let that = this;
    this.timerID = setInterval(() => {
      that.executeReport1(that.state.sessionID);
    }, UPDATE_INTERVAL);
  }

  createCollection(col) {
    let newCol = [];
    for (let i = 0; i < col.length; i++) {
      let obj = {
        id: col[i].c[1], // vehicle name,
        data: []
      };
      for (let j = 0; j < col[i].r.length; j++) {
        if (col[i].r[j].c[3] != "Unknown") {
          let zoneName = col[i].r[j].c[2]; // name of zone that vehicle  entered
          obj.data.push({
            x: col[i].r[j].c[3].t,
            y: this.getIDOfZone(zoneName)
          });
        }
        if (col[i].r[j].c[4] != "Unknown") {
          let zoneName = col[i].r[j].c[2]; // name of zone that vehicle  entered
          obj.data.push({
            x: col[i].r[j].c[4].t,
            y: this.getIDOfZone(zoneName)
          });
        }
      }
      newCol.push(obj);
    }
    return newCol;
  }

  getIDOfZone(zoneName) {
    let index = zones.findIndex(function(item) {
      return item.name == zoneName;
    });
    if (index > -1) {
      return zones[index].myIndex;
    }
    return -1;
  }
  requestFunction() {
    setInterval(this.timer, 1000);
  }

  async buildChartObj3(reportData) {
    let colorsTemp = [];
    let colorsObjectTemp = [];
    let finalColors = [];
    let datasets = []; // empty old data
    // init temp obj

    var obj = {
      name: "",
      data: []
    };
    let pointsTemp = [];
    let addedUnitsList = [];
    for (
      var i = 0;
      i < reportData.length;
      i++ // main loop to iterate through units -> first level
    ) {
      var colr = "#000000";
      var unitName = reportData[i].c[1];
      // check custom color mode
      if (this.state.randomColor) {
        if (colorsObjectTemp.length > 0) {
          var object = colorsObjectTemp.find(function(e) {
            if (e.unitName === unitName) return e;
            return null;
          });

          if (object != null) colr = object.cval;
          if (object == null) {
            colr = this.getRandomColor();
            colorsObjectTemp.push({ unitName: unitName, cval: colr });
          }
        } else {
          colr = this.getRandomColor();
          colorsObjectTemp.push({ unitName: unitName, cval: colr });
        }
      } else {
        let unit = this.state.units.find(function(item) {
          return item.$$user_name == unitName;
        });
        if (unit) {
          let cv = Object.entries(unit.$$user_customFields).find(function(
            cvTemp
          ) {
            return cvTemp[1].n == "chart_color";
          });
          if (cv) {
            colr = cv[1].v.trim();
          }
        }
      }
      obj = {
        name: reportData[i].c[1],
        data: []
      };

      var time = "";
      let outTime = "";
      var index = -1;
      var name = "";

      for (
        var j = 0;
        j < reportData[i].r.length;
        j++ // lopp through details rows
      ) {
        time = reportData[i].r[j].c[3].t;
        if (typeof reportData[i].r[j].c[4].t == "undefined") {
          outTime = time;
        } else {
          outTime = reportData[i].r[j].c[4].t;
        }
        name = reportData[i].r[j].c[2];

        index = this.getZoneId(routesList[this.state.selectedArrName], name);
        if (index != -1) {
          const BGD = 3 * 3600 * 1000; // Baghdad UTC+3 offset in ms
          let ts = reportData[i].r[j].c[3].v * 1000 + BGD;
          let tsOut = typeof reportData[i].r[j].c[4] === "object"
            ? reportData[i].r[j].c[4].v * 1000 + BGD
            : ts;

          obj.data.push([ts, index]);
          obj.data.push([tsOut, index]);
          let ind = addedUnitsList.findIndex(function(item) {
            return item == obj.name;
          });

          if (ind == -1 && reportData[i].r.length > 1) {
            addedUnitsList.push(obj.name);
            finalColors.push(colr);

            let xTemp = tsOut;
            pointsTemp.push({
              x: xTemp,
              y: index,
              marker: {
                size: 0,
                fillColor: "#fff",
                strokeColor: "#2698FF",
                radius: 2
              },
              label: {
                borderColor: "#000",
                offsetY: 0,
                style: {
                  color: "#fff",
                  background: colr
                },

                text: obj.name
              }
            });
          }
        }
      }
      if (obj.data.length > 2) datasets.push(obj);
    }
    await this.setStateAsync({
      dataset: datasets,
      addedUnits: addedUnitsList,
      executing: false,
      points: pointsTemp,
      colors: finalColors
    });
  }
  getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  getZoneId(zones, n) {
    try {
      var zone = zones.find(x => x.name == n);
      return zone.myIndex;
    } catch (e) {
      return -1;
    }
  }
  onChangeTargetObjects(e, value) {
    if (value) {
      let that = this;
      this.setState({
        selectedTargetObject: value,
        exeReportConfig: {
          ...that.state.exeReportConfig,
          type: value.type
        }
      });
    }
  }

  getInitFromDate() {
    var my_date = new Date();
    var first_date = new Date(
      my_date.getFullYear(),
      my_date.getMonth(),
      my_date.getDate() - 1
    );
    return first_date;
  }
  onFromStationChange(e, value) {
    if (value) {
      let routeName = value.name + "_" + value.end_points[0].name;
      let isFound = false;
      let arrayTemp = Object.entries(routesList);
      for (let i = 0; i < arrayTemp.length; i++) {
        if (arrayTemp[i][0] == routeName) {
          isFound = true;
          break;
        }
      }
      let max = -1;
      if (isFound) max = routesList[routeName].length;
      else {
        routeName = value.end_points[0].name + "_" + value.name;
        max = routesList[routeName].length;
      }
      this.setState(
        {
          toList: value.end_points,
          selectedFromStation: value,
          selectedToStation: value.end_points[0],
          selectedArrName: routeName,
          yDirection: value.end_points[0].direction,
          chartConfig: {
            ...this.state.chartConfig,
            max: max
          }
        },
        async () => {
          await this.buildChartObj3(this.state.resultData);
        }
      );
    }
  }
  onToStationChange(e, value) {
    if (value) {
      let routeName = this.state.selectedFromStation.name + "_" + value.name;
      let isFound = false;
      let arrayTemp = Object.entries(routesList);
      for (let i = 0; i < arrayTemp.length; i++) {
        if (arrayTemp[i][0] == routeName) {
          isFound = true;
          break;
        }
      }
      let max = -1;
      if (isFound) max = routesList[routeName].length;
      else {
        routeName = value.name + "_" + this.state.selectedFromStation.name;
        max = routesList[routeName].length;
      }
      this.setState(
        {
          ...this.state,
          selectedToStation: value,
          selectedArrName: routeName,
          yDirection: value.direction,
          chartConfig: {
            ...this.state.chartConfig,
            max: max
          }
        },
        () => this.buildChartObj3(this.state.resultData)
      );
    }
  }
  execute(e) {
    this.setState({
      ...this.state,
      executing: true
    });
    let sessionID = this.state.sessionID;
    this.executeReport1(sessionID);
  }
}
export default App;
